'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../../core/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresReservationExtraServicesWrapperController = function () {
    function WinresReservationExtraServicesWrapperController($rootScope, $scope, $filter, reservationService, localizationService) {
        _classCallCheck(this, WinresReservationExtraServicesWrapperController);

        this.data = null;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$filter = $filter;
        this.reservationService = reservationService;
        this.localizationService = localizationService;
        this.status = null;
    }

    _createClass(WinresReservationExtraServicesWrapperController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            if (!this.winresReservationContext) {
                if (window.definiteWinresReservationContext) {
                    console.log('[winres-reservation-extra-services-wrapper]', 'Context is not available. Falling back to global.');
                    this.winresReservationContext = window.definiteWinresReservationContext;
                } else {
                    throw new Error('A context is required.');
                }
            }

            this.data = this.winresReservationContext.getContext();

            this.$scope.$watch('$ctrl.data.Destination', function () {
                if (_this.data.Destination) {
                    if (_this.dateWatch) {
                        _this.dateWatch(); // Clear watch.
                    }

                    // Reload on date change.
                    _this.dateWatch = _this.$scope.$watchGroup(['$ctrl.data.DefaultStartDate', '$ctrl.data.DefaultEndDate'], function () {
                        return _this.load();
                    }, true);

                    if (_this.numOfPeopleWatch) {
                        _this.numOfPeopleWatch(); // Clear watch.
                    }

                    // Reload on num of people change.
                    _this.numOfPeopleWatch = _this.$scope.$watchGroup(['$ctrl.data.NumAdults', '$ctrl.data.NumChildren', '$ctrl.data.NumInfants'], function () {
                        return _this.load();
                    }, true);
                }
            });

            this.$scope.$on('add-forced-extra-services-to-cart', function () {
                // Accommodation was added when extra services were still loading.
                // Add forced extra services immediately on load.
                _this.addForcedDelay = true;
            });
        }
    }, {
        key: 'clear',
        value: function clear() {
            /*this.extraServicesNormal = [];
            this.extraServicesSimpleForced = [];
            this.extraServicesGroupForced = [];*/
            this.groups = null;
        }
    }, {
        key: 'load',
        value: function load() {
            var _this2 = this;

            this.status = 'loading';

            var lang = this.localizationService.getLanguage();

            var params = this.winresReservationContext.getUrlParams();

            this.clear();

            var destination = _.find(this.data.Products, function (productLine) {
                return _this2.data.Destination.DestinationCode === productLine.Product.DestinationInfo.DestinationCode && (!params || params.ProductCode === undefined || params.ProductCode === productLine.Product.DestinationInfo.ProductCode);
            });

            var parent = {
                DestCode: this.data.Destination.DestinationCode,
                ProdCode: params && params.ProductCode,
                BeginDate: destination !== undefined ? destination.Product.BeginDate : this.data.DefaultStartDate,
                EndDate: destination !== undefined ? destination.Product.EndDate : this.data.DefaultEndDate
            };

            this.reservationService.getExtraServices(lang, parent.BeginDate, parent.EndDate, parent.DestCode, params.NumAdult, params.NumChildren, params.NumInfants).then(function (result) {
                // console.log('[WRESW] Received result: ', result);
                if (result) {
                    // cloneDeep is to prevent modifications in original, cached response.
                    _this2.update(_.cloneDeep(result), parent);
                } else {
                    _this2.status = 'error';
                }
            }, function (error) {
                console.error('Failed to get:', error);
                _this2.status = 'error';
            });
        }

        // This kind of "modify" functions should really be avoided.
        // Instead, new objects with the required fields should be returned.
        // Do not use this as an example for future code.

    }, {
        key: 'modifyGroups',
        value: function modifyGroups(groups, groupType) {
            var _this3 = this;

            var numOfPeople = this.data.NumAdults + this.data.NumChildren;

            _.each(groups, function (group, idx) {
                group.PassengerId = idx;
                group.GroupName = groupType + idx;
                group.GroupIdx = idx;
                group.GroupType = groupType;

                _.each(group.Items, function (item) {
                    //item.GroupType = groupType;
                    //item.GroupId = group.GroupId;

                    if (Array.isArray(item.Price)) item.Prices = item.Price;else {
                        item.Prices = [];
                        item.Prices.push(item.Price);
                    }
                    item.SelectedPrice = item.Prices[0];
                    item.SinglePrice = item.Prices.length === 1;

                    item.SingleAmount = numOfPeople === 1;

                    _this3.calculateItemFreePlaces(item);

                    // Create people amount dropdown.
                    item.Amounts = [];
                    var j = 0;
                    if (groupType === 'Normal') j = 1; // 1 to num of people.
                    for (var i = j; i <= numOfPeople; i++) {
                        item.Amounts.push(i);
                    }

                    // Select default amount.
                    if (item.LinkingInfo.Type === 'Day') {
                        // Day link type.
                        // Generate price label for adults and children.
                        var adultLabel = _this3.data.NumAdults == 1 ? _this3.$filter('i18next')('number_of_people.adult') : _this3.$filter('i18next')('number_of_people.adults');
                        var childLabel = _this3.data.NumChildren == 1 ? _this3.$filter('i18next')('number_of_people.child') : _this3.$filter('i18next')('number_of_people.children');

                        if (!item.LinkingInfo.IsForEachPassenger) {
                            item.Price.Label = (0, _utils.formatDateRange)(item.LinkingInfo.StartDate, item.LinkingInfo.EndDate);
                        } else if (_this3.data.NumChildren > 0) {
                            item.Price.Label = _this3.data.NumAdults + ' ' + adultLabel + ', ' + _this3.data.NumChildren + ' ' + childLabel;
                        } else {
                            item.Price.Label = _this3.data.NumAdults + ' ' + adultLabel;
                        }

                        // Price per day and per person.
                        // Day difference + first day.
                        var days = moment(item.LinkingInfo.EndDate).diff(moment(item.LinkingInfo.StartDate), 'days') + 1;
                        item.Price.Price *= days;

                        if (item.LinkingInfo.IsForEachPassenger) {
                            item.Price.Price *= numOfPeople;
                            item.SelectedAmount = numOfPeople;
                        } else {
                            item.SelectedAmount = 1;
                        }
                    } else if (groupType === 'Normal' && item.LinkingInfo && !item.LinkingInfo.IsForEachPassenger) {
                        item.SelectedAmount = 1;
                    } else if (groupType === 'Normal' && item.LinkingInfo && item.LinkingInfo.IsForEachPassenger) {
                        item.SelectedAmount = numOfPeople;
                    } else if (groupType === 'Normal') {
                        item.SelectedAmount = numOfPeople;
                    } else if (groupType === 'GroupForced' && item.ForcingMultiplier === 'PerPassenger') {
                        item.SelectedAmount = 0;
                    } else if (groupType === 'GroupForced' && item.ForcingMultiplier === 'PerBooking') {
                        item.SelectedAmount = 1;
                    } else if (groupType === 'SimpleForced' && item.ForcingMultiplier === 'PerPassenger') {
                        item.SelectedAmount = numOfPeople;
                    } else if (groupType === 'SimpleForced' && item.ForcingMultiplier === 'PerBooking') {
                        item.SelectedAmount = 1;
                    } else {
                        item.SelectedAmount = numOfPeople;
                    }
                });
            });
            this.filterBlockedItems(groups);
        }
    }, {
        key: 'calculateItemFreePlaces',
        value: function calculateItemFreePlaces(item) {
            item.UsedFreePlaces = 0;
            var product = _.find(this.data.Products, function (productLine) {
                return item.StartDate === productLine.Product.BeginDate && item.EndDate === productLine.Product.EndDate && item.DestCode === productLine.Product.DestinationInfo.DestinationCode && item.ProdCode === productLine.Product.DestinationInfo.ProductCode;
            });
            if (product) item.UsedFreePlaces = product.Amount;
        }

        // Filter out items with blockers.

    }, {
        key: 'filterBlockedItems',
        value: function filterBlockedItems(groups) {
            _.each(groups, function (group) {
                group.Items = _.filter(group.Items, function (item) {
                    if (item.Blockers.length > 0) {
                        console.warn("[WRESW] extra service blocked. Reason:", item.Blockers);
                        return false;
                    }
                    return true;
                });
            });

            // Remove all groups if no items.
            if (_.every(groups, function (group) {
                return group.Items.length === 0;
            })) groups.splice(0, groups.length);
        }
    }, {
        key: 'update',
        value: function update(data, parent) {
            /*if(data.Normal){
                this.extraServicesNormal = data.Normal;
                this.editGroups(this.extraServicesNormal, 'Normal');
                this.filterBlockedItems(this.extraServicesNormal);
            }
            if(data.SimpleForced){
                this.extraServicesSimpleForced = data.SimpleForced;
                this.editGroups(this.extraServicesSimpleForced, 'Simple');
                this.filterBlockedItems(this.extraServicesSimpleForced);
            }
            if(data.GroupForced){
                this.extraServicesGroupForced = data.GroupForced;
                this.editGroups(this.extraServicesGroupForced, 'Group');
                this.filterBlockedItems(this.extraServicesGroupForced);
            }*/

            this.groups = data;
            for (var groupType in this.groups) {
                if (groupType === 'Transport') continue;
                this.modifyGroups(this.groups[groupType], groupType);
            }

            this.status = 'ready';
        }
    }]);

    return WinresReservationExtraServicesWrapperController;
}();

WinresReservationExtraServicesWrapperController.$inject = ['$rootScope', '$scope', '$filter', 'reservationService', 'localizationService'];

_module3.default.component('winresReservationExtraServicesWrapper', {
    template: require('./winresReservationExtraServicesWrapper.html'),
    controller: WinresReservationExtraServicesWrapperController,
    require: {
        winresReservationContext: '?^^winresReservationContext'
    },
    bindings: {
        // Hide normal extra services. (true/false)
        hideNormalExtraServices: '@',

        // Show only normal extra services. (true/false)
        showOnlyNormalExtraServices: '@',

        // Current product.
        searchProduct: '<'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationExtraServicesWrapper/winresReservationExtraServicesWrapper.js
// module id = 489
// module chunks = 2